import "./App.css";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import Dashboard from "./components/dashboard/Dashboard";
import CommanderDashboard from "./components/dashboard/CommanderDashboard";
import OrgDashboard from "./components/dashboard/OrgDashboard";
import Label from "./components/dashboard/Label";
import Simulator from "./components/dashboard/Simulator";
//import Rules from "./components/dashboard/Rules";
import Organization from "./components/organization/Organization";
import User from "./components/organization/User";
import Login from "./components/security/Login";
import Signup from "./components/security/Signup";
import Phone from "./components/dashboard/Phone";
import Logout from "./components/security/Logout";
import UserIdInput from "./components/security/UserIdInput";
import ForgotPassword from "./components/security/ForgotPassword";
import PasswordReset from "./components/security/PasswordReset";
import RequiredAuth from "./RequiredAuth";
import Map from "./Map";
import MapView from "./MapView";

import { ChartStore } from "./store/chartStore";
import { observer } from "mobx-react-lite";
import AddUser from "./components/organization/AddUser";
import Profile from "./components/organization/Profile";
import { Layout, Menu, Dropdown, Modal, Select } from "antd";
import Icon, {
  SettingOutlined,
  BellOutlined,
  DownOutlined,
} from "@ant-design/icons";
import { useEffect, useState } from "react";
import { getUser, getOrganizations } from "./utils/api";
import NewDetailChart from "./components/dashboard/NewDetailChart";
import { ConfigProvider, Button } from "antd";
import ResetProvisioning from "./components/organization/ResetProvisioning";
import Logs from "./components/organization/Logs";

const { Header, Content, Footer } = Layout;
const { Option } = Select;

const MapPin = () => (
  <svg
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 368.553 368.553"
  >
    <path
      d="M184.277,0c-71.683,0-130,58.317-130,130c0,87.26,119.188,229.855,124.263,235.883c1.417,1.685,3.504,2.66,5.705,2.67
    c0.011,0,0.021,0,0.032,0c2.189,0,4.271-0.957,5.696-2.621c5.075-5.926,124.304-146.165,124.304-235.932
    C314.276,58.317,255.96,0,184.277,0z M184.322,349.251C160.385,319.48,69.277,201.453,69.277,130c0-63.411,51.589-115,115-115
    s115,51.589,115,115C299.276,203.49,208.327,319.829,184.322,349.251z"
    />
    <path
      d="M184.277,72.293c-30.476,0-55.269,24.793-55.269,55.269s24.793,55.269,55.269,55.269s55.269-24.793,55.269-55.269
    S214.753,72.293,184.277,72.293z M184.277,167.83c-22.204,0-40.269-18.064-40.269-40.269s18.064-40.269,40.269-40.269
    s40.269,18.064,40.269,40.269S206.48,167.83,184.277,167.83z"
    />
  </svg>
);

function App({ authStore, navStore, dashboardStore, orgDashboardStore }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [organizations, setOrganizations] = useState([]);
  const [orgId, setOrgId] = useState();

  let items = [
    {
      label: "Profile",
      key: "profile",
    },
    {
      label: "Logout",
      key: "logout",
    },
  ];

  if (authStore && authStore.userRole === "admin") {
    items = [
      {
        label: "Organizations",
        key: "organization",
      },
      {
        label: "Users",
        key: "user",
      },
      {
        label: "Switch Organization",
        key: "switch-organization",
      },
      {
        label: "Reset Provisioning",
        key: "reset-provisioning",
      },
      {
        label: "Websockets Logs",
        key: "logs",
      },
      ...items,
    ];
  }
  if (authStore && authStore.userRole === "org_admin") {
    items = [
      {
        label: "Users",
        key: "user",
      },
      ...items,
    ];
  }

  const fetchData = async () => {
    const user = await getUser();
    authStore.updateUser(user);

    if (authStore && authStore.userRole === "admin") {
      const organizations = await getOrganizations();
      setOrganizations(organizations);
    }
  };

  useEffect(() => {
    if (authStore.session !== null) {
      fetchData();
    }
  }, [authStore.session]);

  const [open, setOpen] = useState(false);
  const handleMenuClick = (e) => {
    if (e.key === "switch-organization") {
      setIsModalOpen(true);
      setOpen(false);
    } else {
      document.location = "/" + e.key;
      setOpen(false);
    }
  };

  const handleOk = () => {
    setIsModalOpen(false);
    const org = organizations.find((x) => x.id === orgId);
    dashboardStore.setOrgId(org.id);
    dashboardStore.setOrgName(org.name);
    fetchData();
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleOpenChange = (flag) => {
    setOpen(flag);
  };

  const handleOrgSelect = (orgId) => {
    setOrgId(orgId);
    const org = organizations.find((x) => x.id === orgId);
    dashboardStore.setOrgId(org.id);
    dashboardStore.setOrgName(org.name);
    setIsModalOpen(false);
    fetchData();
  };

  const isAxon =
    authStore &&
    authStore.userOrganization &&
    authStore.userOrganization.name === "AxonDemo";

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#24265a",
        },
      }}
    >
      <div className="App">
        <Modal
          title="Switch Organization"
          open={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
          footer={false}
        >
          <Select
            defaultValue={dashboardStore.orgId}
            style={{ width: 120 }}
            onChange={handleOrgSelect}
          >
            {organizations.map((x) => (
              <Option value={x.id}>{x.name}</Option>
            ))}
          </Select>
        </Modal>

        <Layout className="layout">
          <Header className="header">
            <div className="App__logo">
              <a href="/">
                <img alt="logo" src="/code4.png" style={{ width: "105px" }} />
              </a>
            </div>
            <div className="App__menu">
              {authStore && authStore.userRole === "admin" && <Icon component={MapPin} className="mapIcon" onClick={()=>document.location = "/map-view"}/>}
              <Dropdown
                className="App__menu_icon"
                menu={{
                  items,
                  onClick: handleMenuClick,
                }}
                onOpenChange={handleOpenChange}
                open={open}
              >
                <a onClick={(e) => e.preventDefault()}>
                  <SettingOutlined className="App__menu_icon" />
                </a>
              </Dropdown>
            </div>
          </Header>

          <Content className="content">
            <BrowserRouter>
              <Routes>
                <Route path="/label" element={<Label></Label>} />
                <Route
                  path="/"
                  element={
                    <RequiredAuth authStore={authStore}>
                      {(authStore.user != null &&
                        authStore.userOrganization == null) ||
                      (authStore.userRole === "org_user" &&
                        authStore.user.user_code == null) ? (
                        <UserIdInput authStore={authStore}></UserIdInput>
                      ) : isAxon ? (
                        <OrgDashboard
                          store={ChartStore}
                          navStore={navStore}
                          authStore={authStore}
                          dashboardStore={dashboardStore}
                          orgDashboardStore={orgDashboardStore}
                        ></OrgDashboard>
                      ) : (
                        <CommanderDashboard
                          store={ChartStore}
                          navStore={navStore}
                          authStore={authStore}
                          dashboardStore={dashboardStore}
                          orgDashboardStore={orgDashboardStore}
                        ></CommanderDashboard>
                      )}
                    </RequiredAuth>
                  }
                />
                <Route
                  path="/profile"
                  element={
                    <RequiredAuth authStore={authStore}>
                      <Profile
                        store={ChartStore}
                        navStore={navStore}
                        authStore={authStore}
                      ></Profile>
                    </RequiredAuth>
                  }
                />
                <Route
                  path="/stress-map"
                  element={
                    <RequiredAuth authStore={authStore}>
                      <MapView authStore={authStore}></MapView>
                    </RequiredAuth>
                  }
                />
                <Route
                  path="/map-view"
                  element={
                    <RequiredAuth authStore={authStore}>
                      <MapView authStore={authStore}></MapView>
                    </RequiredAuth>
                  }
                />

                <Route
                  path="/detail-chart"
                  element={
                    <RequiredAuth authStore={authStore}>
                      {authStore.user != null &&
                      authStore.userOrganization == null ? (
                        <UserIdInput authStore={authStore}></UserIdInput>
                      ) : (
                        <Dashboard
                          store={ChartStore}
                          navStore={navStore}
                          authStore={authStore}
                        ></Dashboard>
                      )}
                    </RequiredAuth>
                  }
                />
                <Route
                  path="/detail-stress-chart"
                  element={
                    <RequiredAuth authStore={authStore}>
                      {authStore.user != null &&
                      authStore.userOrganization == null ? (
                        <UserIdInput authStore={authStore}></UserIdInput>
                      ) : (
                        <NewDetailChart
                          store={ChartStore}
                          navStore={navStore}
                          authStore={authStore}
                          dashboardStore={dashboardStore}
                        ></NewDetailChart>
                      )}
                    </RequiredAuth>
                  }
                />
                <Route
                  path="/simulator"
                  element={
                    <RequiredAuth authStore={authStore}>
                      <Simulator
                        authStore={authStore}
                        dashboardStore={dashboardStore}
                        orgDashboardStore={orgDashboardStore}
                      ></Simulator>
                    </RequiredAuth>
                  }
                />
                <Route
                  path="/phone"
                  element={
                    <RequiredAuth authStore={authStore}>
                      <Phone
                        authStore={authStore}
                        dashboardStore={dashboardStore}
                        orgDashboardStore={orgDashboardStore}
                      ></Phone>
                    </RequiredAuth>
                  }
                />
                {/* <Route
                  path="/rules"
                  element={
                    <RequiredAuth authStore={authStore}>
                      <Rules></Rules>
                    </RequiredAuth>
                  }
                /> */}
                <Route
                  path="/organization"
                  element={
                    <RequiredAuth authStore={authStore}>
                      <Organization navStore={navStore} />
                    </RequiredAuth>
                  }
                />
                <Route
                  path="/user"
                  element={
                    <RequiredAuth authStore={authStore}>
                      <User navStore={navStore} authStore={authStore} />
                    </RequiredAuth>
                  }
                />
                <Route
                  path="/organization/user/add"
                  element={
                    <RequiredAuth authStore={authStore}>
                      <AddUser navStore={navStore} authStore={authStore} />
                    </RequiredAuth>
                  }
                />
                <Route
                  path="/login"
                  element={<Login authStore={authStore} navStore={navStore} />}
                />
                <Route
                  path="/signup"
                  element={<Signup authStore={authStore} navStore={navStore} />}
                />
                <Route
                  path="/logout"
                  element={<Logout authStore={authStore} />}
                />
                <Route
                  path="/forgot"
                  element={<ForgotPassword authStore={authStore} />}
                />
                <Route
                  path="/reset"
                  element={<PasswordReset authStore={authStore} />}
                />

                <Route
                  path="/reset-provisioning"
                  element={
                    <RequiredAuth authStore={authStore}>
                      <ResetProvisioning
                        navStore={navStore}
                        authStore={authStore}
                      />
                    </RequiredAuth>
                  }
                />
                <Route
                  path="/logs"
                  element={
                    <RequiredAuth authStore={authStore}>
                      <Logs navStore={navStore} authStore={authStore} />
                    </RequiredAuth>
                  }
                />
              </Routes>
            </BrowserRouter>
          </Content>

          <Footer style={{ textAlign: "center" }}>Code4 Inc.</Footer>
        </Layout>
      </div>
    </ConfigProvider>
  );
}

export default observer(App);
